export const InfoSectionSubHeaderSx = {
  fontSize: '14px',
  color: '#666',
  display: 'inline-block',
  mb: '20px',
};
